import React from 'react'
import HeroSection from '../../components/UI/HeroSection/HeroSection'
import AboutSection from '../../components/UI/aboutsection/AboutSection'
import RegisterAmbulanceBanner from '../../components/UI/registerambulancebanner/RegisterAmbulanceBanner'
import RegisterAmbulance from '../registerambulance/RegisterAmbulance'
import Footer from '../../components/footer/Footer'
import Achievements from '../achievements/Achievements'


const Home = () => {
  return (
    <>
    <HeroSection/>
    <AboutSection/>
    <RegisterAmbulanceBanner/>
    <RegisterAmbulance/>
    <Achievements/>
    <Footer/>
    </>
  )
}

export default Home